/** Routes that run in fullscreen operational kiosk mode (no sidebar / admin header). */
export function isKitchenAppLayout(search: string): boolean {
 return new URLSearchParams(search).get('layout') === 'app'
}

export function isOperationalKioskRoute(pathname: string, search = ''): boolean {
 if (pathname === '/pos'|| pathname.startsWith('/pos/')) return true
 if (pathname === '/kitchen') return !isKitchenAppLayout(search)
 return false
}
